import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useMst } from '../../../models';
import { Link, useNavigate } from 'react-router-dom';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import Page from '../../../layout/Page/Page';
import Card, { CardActions, CardBody, CardFooter, CardFooterRight, CardHeader, CardLabel, CardSubTitle, CardTitle } from '../../../components/bootstrap/Card';
import ReactApexChart from 'react-apexcharts';
import DeviceService from '../../../services/DeviceService';
import HeaderTop from '../HeaderTop';
import HeaderTop_2 from '../HeaderTop_2'
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import InputGroup, { InputGroupText } from '../../../components/bootstrap/forms/InputGroup';
import Input from '../../../components/bootstrap/forms/Input';
import User from '../../../layout/User/User';
import ArDeviceModal from './ArDeviceModal';
import ArUsage from './ArUsage';
import MapModal from '../MapModal';
import { use } from 'i18next';
import PacketService from '../../../services/PacketService';
import ReactSelect from 'react-select';
import { setDate } from 'date-fns';
import moment from 'moment';
import SubHeader from '../../../layout/SubHeader/SubHeader';
import { get, set, transform } from 'lodash';
import { de, he, vi } from 'react-date-range/dist/locale';
import { on } from 'process';
import ArErrorModal from './ArErrorModal';
import UserAddModal from './UserAddModal';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Checks, { ChecksGroup } from '../../../components/bootstrap/forms/Checks';
import UserService from '../../../services/UserService';
import { removeItem } from '../../../lib/localstorage';
import DaumPostcode from 'react-daum-postcode';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../../components/bootstrap/Modal';
import { serachAddress } from '../../../lib/map';
import showNotification from '../../../components/extras/showNotification';
import * as XLSX from 'xlsx';
import Popovers from '../../../components/bootstrap/Popovers';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../../components/bootstrap/Dropdown';
import blueMarker from '../../../assets/marker.svg'
import axios from 'axios';
import { Description } from '../../../components/icon/material-icons';
import weatherDescKo from './weatherDescKo';
import SrErrorModal from './SrErrorModal';
import { color } from 'chart.js/helpers';
import { BagCheck } from '../../../components/icon/bootstrap';



const userId = new URL(window.location.href).searchParams.get('userId');


const datas = [
    { label: '온도', type: 'Temperature_Out', icon: 'Thermometer', value: 25, unit: '℃' },
    { label: '습도', type: 'Humidity_Out', icon: 'Droplet', value: 50, unit: '%' },
    // { label: '내부온도', type: 'Temperature_In', icon: 'Thermometer', value: 25, unit: '℃'},
    // { label: '내부습도', type: 'Humidity_In', icon: 'Water', value: 50, unit: '%'},
    { label: '지온', type: 'Ground_Temperature', icon: 'ThermometerSun', value: 25, unit: '℃'},
    { label: '지습', type: 'Ground_Humidity', icon: 'Moisture', value: 50, unit: '%'},
    { label: 'ph', type: 'pH', icon: 'DropletHalf', value: 7, unit: 'pH'},
    { label: 'EC', type: 'EC', icon: 'WrMoisture', value: 1.5, unit: 'μS/cm'},
    { label: 'CO2', type: 'CO2', icon: 'Wind', value: 500, unit: 'ppm'},
]

const dateTypes = [
    { value: 'daily', label: '일간' },
    { value: 'monthly', label: '월간' },
    { value: 'yearly', label: '연간' },
]

const errorbit = [
    { label: '전체', value: 'all', color: '#F5BB00' },
    { label: '정상', value: 'normal', color: '#E9897E' },
    { label: '배터리부족', value: 'low_battery', color: '#CF6766' },
    { label: '침수', value: 'flood', color: '#5A5A66' },
    { label: '누수', value: 'leak', color: '#A2B8AD' },
    { label: '장기미사용', value: 'long_term_unused', color: '#FFD700' },
    { label: '동파', value: 'freeze', color: '#CF4500' },
    { label: '고온', value: 'high_temperature', color: '#A8DDCA' },
    { label: '검침기 연결', value: 'meter_connection', color: '#008000' },
    { label: '검침기 통신', value: 'meter_communication', color: '#0000FF' },
    { label: 'Data Limit', value: 'data_limit', color: '#800080' },
    { label: '수질 오염', value: 'water_pollution', color: '#A52A2A' },
    { label: '유량 과부화', value: 'flow_overload', color: '#D2691E' },
    { label: '역류', value: 'backflow', color: '#FF00FF' },
    { label: '옥내 누수', value: 'indoor_leak', color: '#1E90FF' },
    { label: '배터리 부족', value: 'low_battery', color: '#8B0000' },
];

const findCenter = (coordinates) => {
    console.log('coordinates', coordinates)
    if (coordinates.length === 0) {
        return null;
    }

    const total = coordinates.reduce(
        (acc, coord) => {
            acc.lat += coord.lat;
            acc.lng += coord.lng;
            return acc;
        },
        { lat: 0, lng: 0 }
    );

    const numCoords = coordinates.length;

    return {
        lat: total.lat / numCoords,
        lng: total.lng / numCoords,
    };
};

const errorLabel = (error) => {
    if (!error) return '정상';
    const reversedString = error.split('').reverse().join('');

    // 오른쪽에서부터 `1`이 나타나는 인덱스를 찾습니다.
    for (let i = 0; i < reversedString.length; i++) {
        if (reversedString[i] === '1') {
            return errorbit[i+2].label;

        }
    }
}

let mapMarkers = []

const MainPage = observer(() => {
    const { user, company, notifiction } = useMst();
    const navigate = useNavigate();
    const { t } = useTranslation(['translation', 'menu']);

    const [dailySum, setDailySum] = useState(0);
    const [monthlySum, setMonthlySum] = useState(0);
    const [yearlySum, setYearlySum] = useState(0);
    const [rank, setRank] = useState([]);
    const [chartLabels, setChartLabels] = useState([]);
    const [chartSeries, setChartSeries] = useState([]);
    const [deviceChartData, setDeviceChartData] = useState([]);
    const [favoriteDevice, setFavoriteDevices] = useState([]);
    const [devices, setDevices] = useState([]);
    const [errors, setErrors] = useState([]);
    const [status, setStatus] = useState('정상');
    const [params, setParams] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [isErrorOpen, setIsErrorOpen] = useState(false);
    const [isUserAddOpen, setIsUserAddOpen] = useState(false);
    const [search, setSearch] = useState('');
    const savedTab = localStorage.getItem('viewTab') || 'MAP';
    const [viewTab, setViewTab] = useState(savedTab);
    const [viewTab2, setViewTab2] = useState('');
    const [detailViewDevice, setDetailViewDevice] =  useState(() => {
        const savedDevice = localStorage.getItem('detailViewDevice');
        return savedDevice ? JSON.parse(savedDevice) : null;
      });
    const [, updateState] = useState(); // 상태 변수는 선언하지 않는다
    const forceUpdate = useCallback(() => updateState({}), []);
    const [selectedIndex, setSelectedIndex] = useState(0);
    
    const [selectedDevice, setSelectedDevice] = useState({});
    const [userInfo, setUserInfo] = useState({});
    const [settings, setSettings] = useState({});
    const [isOpenAddress, setIsOpenAddress] = useState(false);

    const [lastData, setLastData] = useState({});
    const [progress, setProgress] = useState(100);
    const [location, setLocation] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    const [deviceChartData2, setDeviceChartData2] = useState([]);

    const [isSleepOpen, setIsSleepOpen] = useState(false);

    const [isSrOpen, setIsSrOpen] = useState(false);
    const [selectedDevices, setSelectedDevices] = useState([]);

    const [updateTime, setupdateTime] = useState([]);
    
    

    useEffect(() => {
        localStorage.setItem('viewTab', viewTab);
      }, [viewTab]);
    
      useEffect(() => {
        localStorage.setItem('detailViewDevice', JSON.stringify(detailViewDevice));
      }, [detailViewDevice]);

      useEffect(() => {
        const interval = setInterval(() => {
          window.location.reload();
        }, 5 * 60 * 1000); // 5분마다 새로고침
    
        return () => clearInterval(interval);
      }, []);

    useEffect(() => {
        // 위치 정보를 얻는 함수 (예: 브라우저의 Geolocation API 사용)
        navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
        });
    }, []);

    
    const generateRandomCoordinates = (center, range, numPoints) => {
        const { lat, lng } = center;
        const coordinates = [];

        for (let i = 0; i < numPoints; i++) {
            const randomLat = lat + (Math.random() - 0.5) * range;
            const randomLng = lng + (Math.random() - 0.5) * range;
            coordinates.push({ lat: randomLat, lng: randomLng });
        }

        return coordinates;
    }

    const getDeviceChart = useCallback(async (params) => {
		const { data } = await DeviceService.getDeviceChart(params)
		setDeviceChartData2(data)

		let temp = []
		data.filter((x) => x.count > 0).map(d => temp = temp.concat(d.devices))

		setDevices(temp)

	}, [])

    console.log('devicechart2', deviceChartData2);
    console.log('Device', devices)

    useEffect(() => {
		getDeviceChart()
	},[getDeviceChart]);

    const getDevice = useCallback(async () => {
        const { data } = await DeviceService.getDashboardDeviceList()
        // console.log('getDevice', data)

        setDevices(data)
        setFavoriteDevices(data.filter(d => d.favorite))
        if(viewTab === '') setTimeout(() => {setViewTab('MAP')}, 100)
    }, [viewTab])

    useEffect(() => {
        getDevice()
    }, [getDevice, isUserAddOpen]);

    useEffect(() => {
        console.log('viewTab', viewTab)
        console.log('detailViewDevice', detailViewDevice)

        if (detailViewDevice?.packets) {
            setStartTime(detailViewDevice?.packets[0]?.Start_time || '12:05');
            setEndTime(detailViewDevice?.packets[0]?.Sleep_time || '12:00');
        }
        //날씨설정
        if((detailViewDevice?.install?.lat && detailViewDevice?.install.lng)) {
            deviceGetWeather(detailViewDevice?.install?.lat, detailViewDevice?.install?.lng);
        } else{
            navigator.geolocation.getCurrentPosition((position) => {
                let lat = position.coords.latitude;
                let lon = position.coords.longitude;
            deviceGetWeather(lat, lon);
            });
        }

        if (viewTab === 'DETAIL') {
            for (let i = 0; i < datas.length; i++) {
                if (deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][datas[i].type] !== null) {
                    if (selectedIndex < 0) setSelectedIndex(i)
                    else if (deviceChartData[deviceChartData.length - 1][datas[selectedIndex]?.type] === null) setSelectedIndex(i)
                    break;
                }
            }
        } else if (viewTab === 'MAP2') {
            getMaps([detailViewDevice])
        }    

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailViewDevice, viewTab, deviceChartData]);

    // const getLastData = useCallback(async (device) => {
    //     if (device.IMEI) {
    //         const { data } = await PacketService.getPacketList2({ imei: device.IMEI, perPage: 1 })
    //         setLastData(data.list[0])
    //     }
    // }, [])

    const getDevicePacket = useCallback(async (device) => {
        console.log('getDevicePacket', device)
        if (device.IMEI) {
            params.imei = device.IMEI            
            const { data } = await PacketService.getPacketList2(params)
            console.log('Params', params)
            console.log("API Response Data:", data);
            setDeviceChartData(data.list)
            setupdateTime(data.list[data.list.length-1]?.updatedAt)
            console.log('data.list', data.list);
            console.log('업데이트 시간', data.list[data.list.length-1]?.updatedAt);
        } 
    }, [params])

    console.log('devicechartdata', deviceChartData);

    useEffect(() => {
        getDevicePacket(detailViewDevice)
    }, [detailViewDevice, getDevicePacket, params, viewTab]);

    useEffect(() => {
        console.log("Updated deviceChartData:", deviceChartData);
    }, [deviceChartData]);
    

    const updateDevices = useCallback((device) => {
        DeviceService.updateDevices({ devices: [device] }).then((res) => {
            getDevice()
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [devices]);

    useEffect(() => {
        if (favoriteDevice.length > 0) {
            getMaps(favoriteDevice)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [favoriteDevice]);

    // console.log('favoriteDevice', favoriteDevice)

    const getAlarm = useCallback(async () => {
        const { data } = await DeviceService.getAlarmList({ IMEI: favoriteDevice.map(d => d.IMEI)})
        setErrors(data.list)
    }, [favoriteDevice])

    useEffect(() => {   
        if (viewTab === 'MAP') {    
            setDetailViewDevice({})
        }
    }, [viewTab])

    useEffect(() => {
        getAlarm()
    }, [getAlarm]);

    useEffect(() => {
        if (search === '') {
            setFavoriteDevices(devices.filter(d => d.favorite));
            return;
        }
        setFavoriteDevices(devices.filter(d => d.favorite).filter((device) => {
            return device?.IMEI?.includes(search) || device?.SerialNumber?.includes(search) || device?.install?.installName?.includes(search);
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ search]);

    const getMaps = useCallback((markers) => {
        if (!window.kakao) {
            return;
        }   
        if (markers.length === 0) {
            return;
        }
        console.log('markers', markers)
        kakao.maps.load(async () => {
            console.log('get map');
            let container = document.getElementById('kakaoMap');
            if (!container) return
            let center = findCenter(markers.map((device) => device.install).filter((install) => install?.lat && install?.lng));
        
            console.log('center', center)
            if (!center) {
                center = { lat: 37.2087208128284, lng: 127.097707173097 };
            }

            let options = {
                center: new kakao.maps.LatLng(center.lat, center.lng),
                level: 9,
            };

            const map = new window.kakao.maps.Map(container, options);

            // 위성지도 설정
            map.setMapTypeId(window.kakao.maps.MapTypeId.ROADMAP);

            const greenMarkerImage = new window.kakao.maps.MarkerImage(
                blueMarker, // 초록색 마커 이미지 URL
                new window.kakao.maps.Size(24, 35), // 이미지 크기
                {
                    offset: new window.kakao.maps.Point(12, 35), // 이미지의 중앙 하단이 앵커가 되도록 설정
                }
            );

            const redMarkerImage = new window.kakao.maps.MarkerImage(
                'https://map.pstatic.net/resource/api/v2/image/maps/selected-marker/222539@2x.png?version=8&mapping=marker-69', // 빨간색 마커 이미지 URL
                new window.kakao.maps.Size(30, 35), // 이미지 크기
                {
                    offset: new window.kakao.maps.Point(12, 35), // 이미지의 중앙 하단이 앵커가 되도록 설정
                }
            );

            const infowindow = new kakao.maps.InfoWindow({ zIndex: 1 });

            mapMarkers.forEach((marker) => { 
                marker.setMap(null);
            });

            markers.forEach((device, i) => {
                if (device.install?.lat && device.install?.lng) {
                    const marker = new kakao.maps.Marker({
                        title: device.install.installName,
                        position: new kakao.maps.LatLng(device.install.lat, device.install.lng),
                        image: !device.ErrorBit || device.ErrorBit.length === 0 ? greenMarkerImage : redMarkerImage,
                    });
                    kakao.maps.event.addListener(marker, 'click', () => {
                        // infowindow.setContent(`<div style="padding:5px;">${device.install.installName}</div>`);
                        // infowindow.open(map, marker);
                        setDetailViewDevice(device)
                        setViewTab('DETAIL')
                    });
                    marker.setMap(map);
                    mapMarkers.push(marker)
                }
            });

            

            // const circle = new kakao.maps.Circle({
            // 	center: new kakao.maps.LatLng(latitude, longitude), // 원의 중심좌표 입니다
            // 	radius: radius, // 미터 단위의 원의 반지름입니다
            // 	strokeWeight: 1, // 선의 두께입니다
            // 	strokeColor: '#75B8FA', // 선의 색깔입니다
            // 	strokeOpacity: 1, // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
            // 	strokeStyle: 'solid', // 선의 스타일 입니다
            // 	fillColor: '#CFE7FF', // 채우기 색깔입니다
            // 	fillOpacity: 0.7, // 채우기 불투명도 입니다
            // });

            // circle.setMap(map);
        });
    }, []);

    let options = {
        legend: {
            show: true
        },
        series: [{
            name: datas[selectedIndex < 0 ? 0 : selectedIndex].label,
            data: deviceChartData.map(d => d[datas[selectedIndex < 0 ? 0 : selectedIndex].type])
        }],
        labels: deviceChartData.map(d => moment(d.Sensing_Time).format('MM/DD HH:mm:ss')),
        colors: [
            '#06C',
            '#B8BBBE',
            '#5752D1',
            '#C9190B',
            '#4CB140',
            '#009596',
            '#F4C145',
            '#EC7A08',
            '#7D1007',
            '#002F5D',
            '#23511E',
            '#003737',
            '#2A265F',
            '#C58C00',
            '#8F4700',
            '#2C0000',
            '#6A6E73',
        ],
        chart: {
            type: 'line',
            height: 500,
            zoom: {
                enabled: true
            },
            toolbar: {
                show: true
            },
            offsetX: -20
        },
        dataLabels: {
            enabled: true,
            formatter: (value, { dataPointIndex }) => {
                if (value === Math.max(...deviceChartData.map(d => d[datas[selectedIndex].type])) || value === Math.min(...deviceChartData.map(d => d[datas[selectedIndex].type]))) {
                    return value + ' ' + datas[selectedIndex].unit; 
                } else {
                    return '';
                }
            },
            style: {
                colors: ['#F44336', '#E91E63', '#9C27B0', '#673AB7']
            }
        },
        markers: {
            size: 0,
        },
        title: {
            text: '',
            align: 'center'
        },
        stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            width: 1,
            dashArray: 0,
        },
        // fill: {
        //     type: 'gradient',
        //     gradient: {
        //         shade: 'light',
        //         type: "vertical",
        //         opacityFrom: 0.4,
        //         opacityTo: 1,
        //         colorStops: []
        //     },
        // },
        // stroke: {
        // 	show: true,
        // 	lineCap: 'butt',
        // 	colors: undefined,
        // 	width: 1,
        // 	dashArray: 0,
        // },
        // fill: {
        //     type: 'gradient',
        //     gradient: {
        //         shadeIntensity: 1,
        //         // inverseColors: false,
        //         opacityFrom: 0.5,
        //         opacityTo: 0,
        //         stops: [0, 90, 100]
        //     },
        // },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return val;
                },
            },
            title: {
                text: '',
                offsetX: 32,
                offsetY: -222,
                rotate: 0,
            },
        },
        xaxis: {
            tickAmount: 6,
            labels: {
                formatter: function (val, i) {
                    return val;
                },
            },
            title: {
                text: ''
            },
        },
        grid: {
            borderColor: '#e7e7e7',
            row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
            },
        },
        tooltip: {
            shared: false,
            y: {
                formatter: function (val) {
                    return val + ' ' + datas[selectedIndex].unit;
                }
            }
        },
        markers: {
            size: 3, // 점의 크기
            colors: ['#E91E63'], // 점의 색상
            strokeColors: '#fff', // 점의 테두리 색상
            strokeWidth: 2, // 점의 테두리 두께
            shape: "circle", // 점의 모양 (circle, square, triangle 등)
            radius: 2, // 점의 반경
        },
    };

    const styles = {
        topCard: {
            flex: 1,
            // border: '1px solid #49beff',
            backgroundColor: '#fff',
            height: '90vh', 
            transition: '.25s all',
        },
    };

    useEffect(() => {
        forceUpdate()
    }, [viewTab, forceUpdate])
    
    useEffect(() => {   
        setUserInfo(user.me)
        console.log(user.me)
    }, [user.me])

    const addAddress = async (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        try {
            if (data.addressType === 'R') {
                if (data.bname !== '') {
                    extraAddress += data.bname;
                }
                if (data.buildingName !== '') {
                    extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
                }
                fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
            }
            userInfo.address = fullAddress;

            const addressRespons = await serachAddress(fullAddress);
            if (addressRespons.documents) {
                //console.log(addressRespons.documents);
                userInfo.lat = parseFloat(addressRespons.documents[0].y);
                userInfo.lng = parseFloat(addressRespons.documents[0].x);
                userInfo.gu = data.sigungu;
                userInfo.dong = data.bname;
            }
            setUserInfo(userInfo);

        } catch (e) {
            //console.log('');
        } finally {
            setIsOpenAddress(false); // 창닫기
        }
    };

    const excelDownload = async () => {
        let fileName = ''
        showNotification(t('엑셀다운'), t('엑셀 다운로드가 시작 되었습니다.'), 'success')
        let tempData = []
        let data = []

        let i = 0;
        let count = 0;
        fileName = `${moment(params.startDate).format('YYYY년 MM월 DD일')}`

        do {
            params.type = 'DATA'
            params.dateType = 'DAY'
            params.page = Math.floor(tempData.length / 30) + 1
            if (detailViewDevice) {
                params.searchText = detailViewDevice.IMEI
                params.searchType = 'IMEI'
            } else {
                params.searchText = ''
                params.searchType = ''
            }

            const response = await PacketService.getPacketList2(params)
            data = response.data?.list?.reverse() || []
            if (count === 0) count = response.data?.totalCount || 0

            // if (i === 0) {
                // fileName = `${moment(data[0].SensingTime).format('YYYY년 MM월 DD일')}`
            // }
            i++
            tempData = tempData.concat(data)
            user.setProgress(Math.floor((tempData.length / count) * 100))
        } while (data.length > 0 && tempData.length < count)

        // fileName = `${fileName}~${moment(tempData[tempData.length - 1].SensingTime).format('YYYY년 MM월 DD일')}`
        fileName = `${fileName}~${moment(params.endDate).format('YYYY년 MM월 DD일')}`
        // console.log(tempData)
        const wb = XLSX.utils.book_new();
        let temp = []
        tempData.map((x) => {
            temp.push({
                '측정시간': moment(x.Sensing_Time).format('YYYY-MM-DD HH:mm:ss'),
                'IMEI': x.install.IMEI,
                'S/N': x.install.SerialNumber,
                'SIG': x.Sig,
                'MODEL': x.Model,
                'Error': errorLabel(x.Error),
                '절전모드': x.Sleep,
                '온도': x.Temperature_Out,
                '습도': x.Humidity_Out,
                '배터리': x.BAT,
                '지온': x.Ground_Temperature,
                '지습': x.Ground_Humidity,
                'EC': x.EC,
                'pH': x.pH,
                'CO2': x.CO2,
                '통신성공률': x.E_RATE,
                'CID': x.CID,
                'RSSI': x.RSSI,
                'RSRP': x.RSRP,
                'SNR': x.SNR,
                'Version': x.FW_Version,
            })
        })

        const ws = XLSX.utils.json_to_sheet(temp);
        XLSX.utils.book_append_sheet(wb, ws, '데이터');
        XLSX.writeFile(wb, `${fileName}_${moment().format('YYYY년 MM월 DD일')}.xlsx`);
    }

    useEffect(() => {
        setSettings(user.me?.alarm ? JSON.parse(user.me?.alarm) : {})
        forceUpdate()
    }, [user.me, forceUpdate])


    console.log(settings)


    const saveSystemSetting = (e) => {
        console.log({
            e: e,
            id: user.me?.id || 0,
            alarm: settings,
        })
        let data = {
            id: user.me?.id || 0,
            alarm: settings,
        }

        if (e === 'receiveSMS' && !/[0-9]{3}-[0-9]{3,4}-[0-9]{3,4}/i.test(settings.receiveSMS)) {
            Toast.show({
                type: 'error',
                text1: '핸드폰 번호를 확인해주세요.',
                text2: 'setting'
            });
            return
        }

        if (e === 'receiveEmail' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(settings.receiveEmail)) {
            Toast.show({
                type: 'error',
                text1: '잘못된 이메일 형식입니다.',
                text2: 'setting'
            });
            return
        }

        UserService.saveAlarm(data).then((r2) => {
            console.log(r2.data)
            showNotification(t('시스템 설정'), t('시스템 설정 저장 하였습니다.'), 'success');
        })
    }

    const today = new Date();// 현재 날짜를 가져옵니다.

    const formattedDate = `${today.getFullYear()}년 ${today.getMonth() + 1}월 ${today.getDate()}일`; // 원하는 형식으로 날짜를 설정합니다.

    const API_KEY = "9918c03fa05cbe889129e7b2edb955ea";

    useEffect(() => {
        navigator.geolocation.getCurrentPosition((position) => {
            let lat2 = position.coords.latitude;
            let lon2 = position.coords.longitude;

            getWeather(lat2, lon2);
        });
    }, []);

    const [weather, setWeather] = useState({
        location: '',
        humidity: 0,
        temperature: 0,
        temperature_min: 0,
        temperature_max: 0,
        weatherIconUrl: undefined,
        description: '',
        wind_deg: 0,
        wind_speed: 0,
        sunrise: 0,
        sunset: 0,
    });

    const [deviceWeather, setDeviceWeather] = useState({
        location: '',
        humidity: 0,
        temperature: 0,
        temperature_min: 0,
        temperature_max: 0,
        weatherIconUrl: undefined,
        description: '',
        wind_deg: 0,
        wind_speed: 0,
        sunrise: 0,
        sunset: 0,
    });

    const getWeather = async (lat2, lon2) => {
        try {
            const res = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${lat2}&lon=${lon2}&appid=${API_KEY}&units=metric`);
            const data = await res.json()
            console.log("weather",data)

            const location = data.name;
            const temperature = Math.round(data.main.temp);
            const temperature_min = Math.round(data.main.temp_min);
            const temperature_max = Math.round(data.main.temp_max);
            const humidity = data.main.humidity;

            const weatherIcon = data.weather[0].icon;
            const weatherIconUrl = `https://openweathermap.org/img/wn/${weatherIcon}@2x.png`;
            
            const weatherId = data.weather[0].id;
            const description = weatherDescKo[weatherId];

            const wind_deg = data.wind.deg;
            const wind_speed = data.wind.speed;

            const sunrise = data.sys.sunrise;
            const sunset = data.sys.sunset;

            setWeather({
                location,
                temperature,
                temperature_min,
                temperature_max,
                humidity,
                weatherIconUrl,
                description,
                wind_deg,
                wind_speed,
                sunrise,
                sunset,
            });

            
        } catch (error) {
            console.error(error)
        };
    };

    const deviceGetWeather = async (lat2, lon2) => {
        try {
            const res = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${lat2}&lon=${lon2}&appid=${API_KEY}&units=metric`);
            const data = await res.json()
            console.log("weather",data)

            const location = data.name;
            const temperature = Math.round(data.main.temp);
            const temperature_min = Math.round(data.main.temp_min);
            const temperature_max = Math.round(data.main.temp_max);
            const humidity = data.main.humidity;

            const weatherIcon = data.weather[0].icon;
            const weatherIconUrl = `https://openweathermap.org/img/wn/${weatherIcon}@2x.png`;
            
            const weatherId = data.weather[0].id;
            const description = weatherDescKo[weatherId];

            const wind_deg = data.wind.deg;
            const wind_speed = data.wind.speed;

            const sunrise = data.sys.sunrise;
            const sunset = data.sys.sunset;

            setDeviceWeather({
                location,
                temperature,
                temperature_min,
                temperature_max,
                humidity,
                weatherIconUrl,
                description,
                wind_deg,
                wind_speed,
                sunrise,
                sunset,
            });

            
        } catch (error) {
            console.error(error)
        };
    };

    // Unix 타임스탬프 (초 단위)
    const sunriseTime = weather.sunrise;
    const sunsetTime = weather.sunset;

     // Unix 타임스탬프 (초 단위)
     const devSunriseTime = deviceWeather.sunrise;
     const devSunsetTime = deviceWeather.sunset;

    // Date 객체로 변환
    const sunrisedate = new Date(sunriseTime * 1000); // 초 단위를 밀리초로 변환
    const sunsetdate = new Date(sunsetTime * 1000)

    const devsunrisedate = new Date(devSunriseTime * 1000); // 초 단위를 밀리초로 변환
    const devsunsetdate = new Date(devSunsetTime * 1000)

    var TimeOption = {hour : "numeric", minute:"numeric", second:"numeric", hour12: false};
    // 읽기 쉬운 형식으로 변환
    const sunriseDate = sunrisedate.toLocaleTimeString(); // 예: '2021-10-13 10:05:12'
    const sunsetDate = sunsetdate.toLocaleTimeString();

    const devsunriseDate = devsunrisedate.toLocaleTimeString("en-US", TimeOption); // 예: '2021-10-13 10:05:12'
    const devsunsetDate = devsunsetdate.toLocaleTimeString("en-US", TimeOption);


    const handleDeviceSelect = (deviceTab) => {
        setDetailViewDevice(deviceTab);
        setViewTab('DETAIL'); // 선택한 기기의 탭으로 이동
        setIsSrOpen(false); // 모달 닫기
    };
    

    //값의 임계값 지정
    const alarmDonut = (type) => {
        if (type === 'Temperature_Out') {
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 25;  // true 또는 false 반환
        }

        if (type === 'Humidity_Out') {
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 90;  // true 또는 false 반환
        }

        else if (type === 'Ground_Temperature'){
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 25;
        }

        else if (type === 'Ground_Humidity'){
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 100;
        }

        else if (type === 'pH'){
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 6.5;
        }

        else if (type === 'EC'){
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 5;
        }

        else if (type === 'CO2'){
            return deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][type] < 600;
        }
    }

    return (
        <PageWrapper className='fluid' title={t('대시보드')} >
            <SubHeader className={'belt-header'} >
                <div className='d-flex flex-row justify-content-between'>
                    
                    <div style={{ marginTop: 4, marginLeft: 50 }} className='d-flex flex-row justify-content-between pointer' onClick={() => { setViewTab('MAP') }}>
                        <Icon icon='House-Fill' color='light' fontSize={25} forceFamily='bootstrap' />
                        <div style={{paddingLeft: 10, marginTop: -2}}>
                            <span style={{color:'#fff', fontSize: '1.5rem', fontWeight: 800}}>{t(user.me.nickname || user.me.name)}</span>
                        </div>
                        
                    </div>
                
                    <div className='d-flex flex-row justify-content-end' style={{paddingTop: 2}}>
                        <Dropdown>
                            <DropdownToggle>
                                <Icon className="pointer" fontSize={28} color='light' style={{ marginRight: 20 }} isOutline icon={'Person'} forceFamily='bootstrap' ></Icon>
                            </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem>
                                <Button
                                    icon='AccountBox'
                                    onClick={() => setViewTab('PROFILE')}>
                                    {t('Profile')}
                                </Button>
                            </DropdownItem>
                            <DropdownItem isDivider />
                            <DropdownItem>
                                <Button
                                    icon='Logout'
                                    className='belt-title'
                                    color={'light'}
                                    onClick={async () => {
                                        UserService.logout().then(async () => {
                                            await Promise.all([
                                                removeItem('access-token'),
                                                removeItem('refresh-token'),
                                                removeItem('rootState'),
                                                removeItem('webToken'),
                                                removeItem('authUser'),
                                                user.logout(),
                                            ]).then(() => {
                                                navigate(`/login`);
                                            });
                                        });
                                    }}>
                                    {t('로그아웃')}
                                </Button>
                            </DropdownItem>
                        </DropdownMenu>
                        </Dropdown>
                        <Icon className="pointer" fontSize={28} color='light' isOutline icon={'Gear'} forceFamily='bootstrap' onClick={() => { setViewTab('SETTING') }}></Icon>
                    </div>
                </div>
            </SubHeader>

            <div style={{backgroundColor: '#ffffff', height: 5, marginRight: -10, marginLeft: -10}}></div>
            
            <div className='row' style={{paddingTop: 10}}>
                {/* 사이드 기기 목록 */}
                <div className='col-xl-2 col-lg-2 col-md-2 text-center'>
                    <Card className={`custom-box-shadow rounded-2 belt-header`} style={{ padding: 0, marginLeft: 0, marginRight: 0, height: 65, marginTop:0 }}>
                        <CardBody className={`rounded-2 align-items-center text-center`} style={{padding: '1rem'}} >
                            <div className='d-flex flex-column justify-content-between' style={{marginTop: 0}}>
                            <InputGroup>
                                <Input 
                                    type='text' 
                                    placeholder='별칭, IMEI, S/N' 
                                    style={{
                                        borderRadius: 10,
                                        borderTopRightRadius: 10,
                                        borderBottomRightRadius: 10,
                                        border: '1px solid #5d87ff',
                                        backgroundColor: '#fff',
                                    }}
                                    value={search} onChange={(e) => {
                                        setSearch(e.target.value);
                                    }} />

                                    <Icon 
                                        style={{
                                            cursor: 'pointer', 
                                            marginLeft: 10, 
                                            marginTop: 5
                                        }}
                                        color='light'
                                        icon='LibraryAdd' 
                                        fontSize={30}
                                        onClick={(e) => {
                                            setIsOpen(true)
                                        }}
                                    />
                            </InputGroup>
                            </div>
                        </CardBody>
                    </Card>
                    {/* <Card className={` custom-box-shadow rounded-2`} style={{padding: 0, marginLeft: 0, marginRight: 0 }}>
                        <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '1rem' }} > */}
                        <div className='d-flex flex-column justify-content-between' style={{marginTop: -5}}>
                            <div style={{ overflowY: 'auto', height: 'calc(90vh - 85px)', scrollbarWidth: 'none'}}>
                            {favoriteDevice
                                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                                    .map((d, i) => (
                                    <Card key={i} className={`custom-box-shadow rounded-2`}
                                        style={{ marginTop: 10, cursor: 'pointer'}}
                                        onClick={(e) => {
                                            console.log('click', d);
                                            setDetailViewDevice(d)
                                            setParams(d); //수집 데이터 클릭 후 다시 detail 탭으로 들어가 기기를 클릭했을 때 변경되지 않는 차트 문제 해결(sh)
                                            //if (viewTab !== 'DATA') setViewTab('DETAIL')
                                            setViewTab('DETAIL')
                                            localStorage.setItem('detailViewDevice', JSON.stringify(d.IMEI)) // localStorage에 저장
                                            localStorage.setItem('viewTab', 'DETAIL')
                                        }}
                                    >
                                        <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '1rem', background: detailViewDevice.IMEI === d.IMEI ? 'linear-gradient(#a6c7f7, #a4c5f5)' : '#ffffff', color: '#000' }}>
                                            <div className='d-flex flex-row justify-content-between'>
                                                
                                                <div><CardTitle style={{ color: '#27547b', fontSize: '1.5rem', marginTop: 0 }}>{d?.install?.installName || '별칭없음'}</CardTitle></div>  {/*color: '#6183DB' */}
                                                <div><b>{d?.updatedAt}</b></div>
                                                
                                                <div>
                                                    <Icon icon='Gear-Fill' fontSize={20} forceFamily='bootstrap' 
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            e.preventDefault()
                                                            e.nativeEvent.stopPropagation()
                                                            e.nativeEvent.preventDefault()
                                                            setSelectedDevice(d)
                                                            setIsUserAddOpen(true)
                                                        }}
                                                     />
                                                    <Icon icon='Close' fontSize={25} onClick={(e) => {
                                                        e.stopPropagation()
                                                        e.preventDefault()
                                                        e.nativeEvent.stopPropagation()
                                                        e.nativeEvent.preventDefault()
                                                        d.favorite = false
                                                        updateDevices(d)
                                                    }} style={{cursor:'pointer'}} />
                                                </div>
                                            </div>
                                            <div className='w-100 text-left' style={{ marginTop: 0 }}>

                                                <div className='d-flex flex-row justify-content-between'>
                                                    
                                                        
                                                    <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>Model <div><span>{d?.Model}</span></div></div>
                                                    <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>버전 <div><span>{d?.FW_Version}</span></div></div>
                                                    
                                                </div>
                                                <div className='d-flex flex-row justify-content-between'>

                                                    
                                                <div style={{ fontSize: '1.0rem' }}>IMEI {d?.IMEI}</div>
                                                    {/* <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>IMEI <div><span>{d?.IMEI}</span></div></div> */}
                                                    {/* <div style={{  fontSize: '1.0rem' }}>S/N {d?.SerialNumber}</div> */}
                                                    <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>S/N <div><span>{d?.SerialNumber}</span></div></div>
                                                    
                                                    
                                                    
                                                </div>
                                                
                                                
                                                <hr />
                                                {(d.packets.length > 0 && (d.packets[0]?.BAT !== null || d.packets[0]?.CO2 !== null)) &&
                                                <div className='d-flex flex-row justify-content-between' style={{ marginTop: 2 }}>
                                                                    {(d.packets.length > 0 && d.packets[0]?.BAT !== null) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>배터리<div><span style={{ color: "blue" }}><b>{d.packets[0]?.BAT}</b></span> %</div></div>}
                                                                    {(d.packets.length > 0 && d.packets[0]?.CO2 != null) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>CO2 <div><span style={{ color: "blue" }}><b>{d.packets[0]?.CO2}</b></span> ppm</div></div>}
                                                </div>}
                                                {(d.packets.length > 0 && (d.packets[0]?.Temperature_Out !== null || d.packets[0]?.Humidity_Out !== null)) &&
                                                <div className='d-flex flex-row justify-content-between' style={{ marginTop: 2 }}>
                                                        {(d.packets.length > 0 && (d.packets[0]?.Temperature_Out !== null)) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'> 온도 <div><span style={{ color: "blue" }}><b>{d.packets[0]?.Temperature_Out}</b></span> ℃</div></div>}
                                                        {(d.packets.length > 0 && (d.packets[0]?.Humidity_Out !== null)) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'> 습도 <div><span style={{ color: "blue" }}><b>{d.packets[0]?.Humidity_Out}</b></span>  %</div></div>}
                                                </div>
                                                }
                                                {(d.packets.length > 0 && (d.packets[0]?.Ground_Temperature !== null || d.packets[0]?.Ground_Humidity !== null)) &&
                                                <div className='d-flex flex-row justify-content-between' style={{ marginTop: 2 }}>
                                                        {(d.packets.length > 0 && d.packets[0]?.Ground_Temperature !== null) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>지온 <div><span style={{ color: "blue" }}><b>{d.packets[0]?.Ground_Temperature}</b></span> ℃</div></div>}
                                                            {(d.packets.length > 0 && d.packets[0]?.Ground_Humidity !== null) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>지습 <div><span style={{ color: "blue" }}><b>{d.packets[0]?.Ground_Humidity}</b></span>%</div></div>}
                                                </div>}
                                                {(d.packets.length > 0 && (d.packets[0]?.pH !== null || d.packets[0]?.EC !== null)) &&
                                                <div className='d-flex flex-row justify-content-between' style={{ marginTop: 2 }}>
                                                        {(d.packets.length > 0 && d.packets[0]?.pH != null) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>ph <div><span style={{ color: "blue" }}><b>{d.packets[0]?.pH}</b></span> pH</div></div>}
                                                        {(d.packets.length > 0 && d.packets[0]?.EC != null) && <div style={{ width: '40%' }} className='d-flex flex-row justify-content-between'>EC <div><span style={{ color: "blue" }}><b>{d.packets[0]?.EC}</b></span> dS/m</div></div>}
                                                </div>}
                                                
                                                {d.Error && d.ErrorBit.length > 0 && <div className='d-flex flex-row justify-content-between' style={{ marginTop: 2 }}>
                                                    <div style={{ width: '100%' }}>이상감지 <span style={{ color: "red" }}><b>{errorLabel(d.Error)}</b></span></div>
                                                </div>}
                                            </div>{/*원래 색 #4370e0 */}
                                            {/* <div className='w-100 text-left' style={{ marginTop: 0 }}>
                                                <div>IMEI: {d?.IMEI}</div>
                                                <div>S/N: {d?.SerialNumber}</div>
                                                <div>온도: {deviceChartData.length > 0 ? deviceChartData[0]?.Temperature_In : ''}℃ 습도: {deviceChartData.length > 0  ? deviceChartData[0]?.Humidity_In : ''}%</div>
                                                <div>지온: {deviceChartData.length > 0  ? deviceChartData[0]?.Ground_Temperature : ''}℃ 지습: {deviceChartData.length > 0  ? deviceChartData[0]?.Ground_Humidity : ''}%</div>
                                                <div>ph: {deviceChartData.length > 0  ? deviceChartData[0]?.pH : ''} EC: {deviceChartData.length > 0  ? deviceChartData[0]?.EC : ''}dS/m CO2: {deviceChartData.length > 0  ? deviceChartData[0]?.CO2 : ''}ppm</div>
                                            </div> */}
                                        </CardBody>
                                    </Card>
                                ))}
                            </div>
                            </div>
                        {/* </CardBody>
                    </Card> */}
                </div>
                {/* Body */}
                <div className='col-xl-10 col-lg-10 col-md-10 text-center'>
                    {((viewTab === 'DETAIL' || viewTab === 'DATA' || viewTab === 'MAP2') && detailViewDevice?.IMEI) && (
                        <div>
                             <Card className={`custom-box-shadow rounded-2`} style={{ padding: 10, marginLeft: 0, marginRight: 0 }}>
                                <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row justify-content-between`} style={{ padding: 0 }}>
                                    <CardTitle style={{ fontFamily: 'KCC-Hanbit', fontSize: 30, fontWeight: 'Normal',marginLeft: 20, marginTop: 6 }}>{viewTab === 'MAP2' ? '단말기 위치 데이터' : detailViewDevice.install.installName+' Dashboard'}</CardTitle>
                                    <Button color='light'
                                        icon={viewTab === 'DETAIL' || viewTab === 'OPTION' ? 'Description' : 'BarChart'}
                                        size='lg'
                                        style={{ marginTop: 5, marginRight: 10 }}
                                        onClick={() => {
                                            setViewTab(viewTab === 'DETAIL' || viewTab === 'OPTION' ? 'DATA' : 'DETAIL')
                                        }}>
                                        {'수집 데이터'}
                                    </Button>
                                </CardBody>
                            </Card>                           
                        </div>
                    )}
                    {(viewTab === 'MAP' || (viewTab === 'DATA' && !detailViewDevice?.IMEI)) && (
                        <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0 }}>
                            <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row justify-content-between`} style={{ padding: '0.93rem' }}>
                                <div style={{fontFamily: 'KCC-Hanbit', fontSize: 30}}>
                                    {t(user.me.nickname || user.me.name)}
                                    
                                </div>
                                {/* <Button color='info' size='lg'>전체 단말기 수 {devices.length}</Button> */}
                                <div>
                                    <Button color='light' icon={viewTab === "DATA" ? "House-Fill" : "Description"} onClick={() => setViewTab(viewTab === 'DATA' ? 'MAP' : 'DATA')}>{viewTab === 'DATA' ?  '홈' : '수집 데이터'}</Button>
                                </div>
                                {/* <Button color='danger' size='lg'>이상 단말기 수 {devices.filter(f => f.Error).length}</Button> */}
                            </CardBody>
                        </Card>
                       
                    )}
                    {(viewTab === 'DATA' && !detailViewDevice?.IMEI) && (                
                        <Card className={`custom-box-shadow rounded-2`} style={{ height: viewTab === 'DATA' ? 'calc(90vh - 85px)' : 'calc(105vh - 280px)', padding: 0, marginLeft: 0, marginRight: 0 }}>
                            <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row`} style={{ padding: '1rem' }}>
                                <div className='d-flex flex-column' style={{ flex: 1, padding: 10, marginTop: -20, height: viewTab === 'DATA' ? '100%' : '100%' }}>
                                    <HeaderTop setParams={setParams} progress={progress} excelDownload={excelDownload}
                                        disableExcelUp disableMap
                                        startDate={params.startDate || moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss')}
                                        endDate={params.endDate || moment().format('YYYY-MM-DD HH:mm:ss')}
                                        type={'SR'}  disableSecond={detailViewDevice} />

                                        <ArUsage detailViewDevice={detailViewDevice} params={params} style={{ marginTop: -10 }} setDetailViewDevice={setDetailViewDevice} />
                                </div>
                            </CardBody>
                        </Card>
                    )}
                    {/* 데이터 리스트  */}
                    {((viewTab === 'DETAIL' || viewTab === 'DATA') && detailViewDevice?.IMEI) && (
                        <div className='col-xl-12 col-lg-12 col-md-12 text-center'>

                            {viewTab === 'DETAIL' && (
                                <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0 , background: 'linear-gradient(#617dac, #91AEC4)'}}>
                                    <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row justify-content-around`} style={{ padding: '0.93rem', background: 'linear-gradient(#617dac, #91AEC4)'}}>
                                        {datas.map((data, i) => (
                                            <div key={i} className='d-flex' onClick={() => {
                                                if (deviceChartData[deviceChartData.length - 1] && deviceChartData[deviceChartData.length - 1][data.type] !== null) setSelectedIndex(i)
                                            }} style={{ cursor: deviceChartData[deviceChartData.length - 1] && deviceChartData[deviceChartData.length - 1][data.type] !== null ? 'pointer' : 'not-allowed' }}>
                                                <Card stretch className={`d-flex`} style={{opacity: selectedIndex === i ? 1 : 1,
                                                    width: 150, textAlign: 'center', marginTop: 20, background: 'linear-gradient(#617dac, #91AEC4)',  borderRadius: '50%'
                                                    //border: deviceChartData[deviceChartData.length - 1] && deviceChartData[deviceChartData.length - 1][data.type] !== null ? (selectedIndex === i ? '2px solid #3e66c4' : '1px solid #aaaaaa') : '1px solid #aaaaaa',
                                                     }}>
                                                    <CardBody className={` align-items-center text-center`} 
                                                        style={{
                                                            background: deviceChartData[deviceChartData.length - 1] && deviceChartData[deviceChartData.length - 1][data.type] !== null ? (selectedIndex === i ? (alarmDonut(data.type) ? '#e8f7ff' : '#fffbf0') :'linear-gradient(#617dac, #91AEC4)' ) : 'linear-gradient(#617dac, #91AEC4)', 
                                                            color: deviceChartData[deviceChartData.length - 1] && deviceChartData[deviceChartData.length - 1][data.type] !== null ? (selectedIndex === i ?  (alarmDonut(data.type) ? '#27547b':'#db8c32'): '#fff') : '#91AEC4', borderRadius: '50%'}}>
                                                        <Icon  icon={data.icon} fontSize={30} forceFamily='bootstrap' />
                                                        <CardTitle style={{ fontSize: '1.8rem', marginTop: 10 }}>{data.label}</CardTitle>
                                                        <CardSubTitle className='mt-3' style={{ fontSize: 15, marginTop: 20 }}><strong style={{fontSize: 28}}>{deviceChartData.length > 0 && (deviceChartData[deviceChartData.length - 1][data.type])}</strong>{data.unit}</CardSubTitle>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        ))}
                                    </CardBody>
                                </Card>
                            )}

                        <div className='row text-center'>
                        {viewTab === 'DETAIL' && (
                            <div className ='col-xl-8 col-lg-8 col-md-8 text-center'>
                            <Card className={`custom-box-shadow rounded-2`} style={{ height: 'calc(86vh - 276px)', padding: 0, marginLeft: 0, marginRight: 0 }}>
                                <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row`} style={{ padding: '1rem' }}>
                                    <div className='d-flex flex-column' style={{ flex: 1, padding: 10, marginTop: -20, height: viewTab === 'DATA' ? '100%' : '100%'}}>
                        
                                    <div className='d-flex flex-row' style={{fontFamily: 'KCC-Hanbit', marginBottom: -10}}>
                                    <h5><b>{datas[selectedIndex].label}의 추이</b></h5>
                                    </div>
                                    <HeaderTop_2 setParams={setParams} progress={progress} excelDownload={excelDownload} 
                                        disableExcelUp disableMap
                                        startDate={params.startDate || moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')} 
                                        endDate={params.endDate || moment().format('YYYY-MM-DD HH:mm:ss')}
                                        type={'SR'} disableSecond={detailViewDevice} />
                                     <ReactApexChart                                            
                                                style={{ paddingLeft: 20, flex: 1}}
                                                width={'100%'}
                                                height={'95%'}
                                                options={options}
                                                series={options.series}
                                                type={'line'}/>
                                     </div>
                                        </CardBody>
                                    </Card>
                            </div> 
                        )}
                        {viewTab === 'DATA' && (
                            
                        <div className='col-xl-12 col-lg-12 col-md-12 text-center'>
                        <Card className={`custom-box-shadow rounded-2`} style={{ height: viewTab === 'DATA' ? 'calc(90vh - 85px)' : 'calc(105vh - 280px)', padding: 0, marginLeft: 0, marginRight: 0 }}>
                            <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row`} style={{ padding: '1rem' }}>
                                <div className='d-flex flex-column' style={{ flex: 1, padding: 10, marginTop: -20, height: viewTab === 'DATA' ? '100%' : '100%' }}>
                                    <HeaderTop setParams={setParams} progress={progress} excelDownload={excelDownload}
                                        disableExcelUp disableMap
                                        startDate={params.startDate || moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss')}
                                        endDate={params.endDate || moment().format('YYYY-MM-DD HH:mm:ss')}
                                        type={'SR'}  disableSecond={detailViewDevice} />

                                        <ArUsage detailViewDevice={detailViewDevice} params={params} style={{ marginTop: -10 }} />
                                </div>
                            </CardBody>
                        </Card>
                        </div>
                                
                        )}
                            {/* <div className ='col-xl-8 col-lg-8 col-md-8 text-center'>
                                            <Card className={`custom-box-shadow rounded-2`} style={{ height: viewTab === 'DATA' ?  'calc(90vh - 85px)' : 'calc(86vh - 276px)', padding: 0, marginLeft: 0, marginRight: 0 }}>
                                                <CardBody className={`rounded-2 align-items-center text-center d-flex flex-row`} style={{ padding: '1rem' }}>
                                                    <div className='d-flex flex-column' style={{ flex: 1, padding: 10, marginTop: -20, height: viewTab === 'DATA' ? '100%' : '100%'}}>
                                        
                                                    <div className='d-flex flex-row' style={{fontFamily: 'KCC-Hanbit', marginBottom: -10}}>
                                                    {viewTab === 'DATA' ? ('') : (
                                                        <h5><b>{datas[selectedIndex].label}의 추이</b></h5>
                                                        )}
                                                    </div>
                                                    <HeaderTop_2 setParams={setParams} progress={progress} excelDownload={excelDownload} 
                                                        disableExcelUp disableMap
                                                        startDate={params.startDate || moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')} 
                                                        endDate={params.endDate || moment().format('YYYY-MM-DD HH:mm:ss')}
                                                        type={'SR'} disableSecond={detailViewDevice} />
                                                        
                                                        
                                        {viewTab === 'DATA' ? ( 
                                                                                                                        
                                            <ArUsage detailViewDevice={detailViewDevice} params={params} style={{marginTop: -10}}/>
                                            
                                            
                                        ) : (                                    
                                            <ReactApexChart                                            
                                                style={{ paddingLeft: 20, flex: 1}}
                                                width={'100%'}
                                                height={'95%'}
                                                options={options}
                                                series={options.series}
                                                type={'line'}/>                                       
                                            )}
                                            </div>
                                        </CardBody>
                                    </Card>
                            </div>  */}
                                        
                            

                            <div className='col-xl-4 col-lg-4 col-md-4 text-center'>
                            
                            {viewTab === 'DETAIL' && (
                                <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0}} >
                                    <CardBody className={`rounded-2 align-items-center text-left`} style={{ padding: '0.93rem' }}> 
                                    <div className='d-flex flex-row justify-content-between'>
                                        <div style={{fontFamily: 'KCC-Hanbit'}}>
                                            <h5><b>{formattedDate}</b></h5>
                                        </div>
                                    </div>
                                    <div className='d-flex flex-column align-items-left text-left justify-content-left'style={{fontFamily:'KCC-Hanbit', paddingTop: 10}}>                                               
                                        <span style={{fontSize: `${Math.max(10, window.innerWidth * 0.005)}px`, color : '#000'}}>{deviceWeather.location} <Icon icon='Location' fontSize={`${Math.max(10, window.innerWidth * 0.01)}px`}/></span>
                                        <div className='d-flex flex-row'style={{ fontSize: `${Math.max(10, window.innerWidth * 0.008)}px`, marginTop: 10}}>
                                        <div style={{color : '#27547b', marginRight:70}}><Icon icon='Sunrise' fontSize={`${Math.max(10, window.innerWidth * 0.01)}px`} forceFamily='bootstrap'  style={{color : '#f27b35'}}/>  {devsunriseDate}</div>
                                        <div style={{color : '#27547b', marginRight:70}}><Icon icon='Sunset' fontSize={`${Math.max(10, window.innerWidth * 0.01)}px`} forceFamily='bootstrap' style={{color : '#f27b35'}} />  {devsunsetDate}</div>
                                        <div style={{color : '#27547b', marginRight:70}}><Icon style={{}}icon='Wind' fontSize={`${Math.max(10, window.innerWidth * 0.01)}px`} forceFamily='metaria-icon'  /> 
                                        {deviceWeather.wind_speed}m/s</div>
                                        <div style={{color : '#27547b'}}><Icon  style={{transform: 'rotate('+((deviceWeather.wind_deg))+'deg)', transition: 'transform 0.3s ease', marginLeft: -3}}icon='WindDeg' fontSize={`${Math.max(10, window.innerWidth * 0.008)}px`}   />
                                        {deviceWeather.wind_deg}°</div>
                                        </div>
                                        
                                        <div className='d-flex flex-column'style={{ fontSize: `${Math.max(10, window.innerWidth * 0.008)}px`}}>
                                        <div style={{ color : '#27547b', marginTop: 5}}><img src={deviceWeather.weatherIconUrl} alt="Weather Icon" style={{ width: 50, height: 50, marginLeft:-10 }}/>{deviceWeather.description}</div>
                                       
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>                                                                          
                            )}
                                <div className={'col-xl-12  col-lg-12  col-md-12 '}>   
                                {viewTab === 'DETAIL' && (                             
                                <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0, marginTop: 0, height:'calc(55vh - 150px)'}}>
                                    <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '0.5rem' }}>
                                        {getMaps([detailViewDevice])}
                                        <div                                            
                                            className='position-relative border w-100 d-inline-block bg-l25-light border'
                                            style={{
                                                width: '100%', height: '100%'
                                            }}>
                                            <div id='kakaoMap' className='kakao-map' style={{ width: '100%', height: '100%' }}></div>
                                        </div>
                                    </CardBody>
                                </Card> 
                                )}                                                              
                                </div>
                        
                                
                            </div>
                        </div>
                        </div>
                    )}
                    {(
                        <div style={{ display: viewTab === 'MAP' || viewTab === 'MAP2' ? '' : 'none'}}>
                        <div>
                            
                            <div className='row col-xl-12 col-lg-12 col-md-12  text-center' style={{marginLeft: 2}}>
                                {(viewTab === 'MAP' &&!detailViewDevice?.IMEI)&&(
                            
                                <Card className='col-xl-3 col-lg-3 col-md-3 text-center custom-box-shadow rounded-2'style={{background: 'linear-gradient(#617dac, #91AEC4)',color: '#ffffff'}}>
                                    <CardBody className={` rounded-2 d-flex flex-row justify-content-left`} >
                                    <div className=' d-flex flex-column text-left'><text style={{fontSize: 20, fontFamily: 'KCC-Hanbit', marginTop: 5, marginBottom: 15}}>장비 현황<text style={{fontSize: 15}}> (전체 단말기 수 {devices.length})</text></text> {/*{t(user.me.nickname || user.me.name)} */}
                                        <div className='d-flex flex-row'>
                                            <ReactApexChart
                                                options={{
                                                    // title: {
                                                    //     text: '장비 현황',
                                                    //     align: 'center'
                                                // }, 
                                                    colors: deviceChartData2.filter((x) => x.count > 0).map((x) => x.color),
                                                    chart: {
                                                        type: 'donut',
                                                        height: 250,
                                                        events: {
                                                            dataPointSelection: (event, chartContext, config) => {
                                                                // 데이터 포인트가 클릭되었을 때 실행될 함수
                                                                console.log("Data Point Clicked: ", config.dataPointIndex);
                                                                console.log("Series Index: ", config.seriesIndex);
                                                                
                                                                // 에러 모달 열기
                                                                setSelectedDevices(deviceChartData2.filter((x) => x.count > 0)[config.dataPointIndex].devices)
                                                                setStatus(deviceChartData2.filter((x) => x.count > 0)[config.dataPointIndex].label)
                                                                setIsSrOpen(true);
                                                                // 원하는 동작을 추가하세요
                                                            }
                                                        },
                                                    },
                                                    stroke: {
                                                        width: 0,
                                                    },
                                                    labels: deviceChartData2.filter((x) => x.count > 0).map((x) => x.label),
                                                    dataLabels: {
                                                        enabled: false,
                                                    },
                                                    plotOptions: {
                                                        pie: {
                                                            expandOnClick: true,
                                                            donut: {
                                                                labels: {
                                                                    show: true,
                                                                    name: {
                                                                        show: true,
                                                                        fontSize: '24px',
                                                                        fontFamily: 'Poppins',
                                                                        fontWeight: 900,
                                                                        offsetY: 0,
                                                                        formatter(val) {
                                                                            return val;
                                                                        },
                                                                    },
                                                                    value: {
                                                                        show: true,
                                                                        fontSize: '16px',
                                                                        fontFamily: 'Poppins',
                                                                        fontWeight: 900,
                                                                        offsetY: 16,
                                                                        formatter(val) {
                                                                            return val;
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                    legend: {
                                                        show: false,
                                                        position: 'bottom',
                                                        floating: true,
                                                        offsetY: 100,
                                                        height: 200,
                                                        showForSingleSeries: true
                                                    },
                                                }}
                                                series={deviceChartData2.filter((x) => x.count > 0).map((x) => x.count)}
                                                width={'100%'}
                                                type={'donut'}
                                                height={250}
                                            />
                                            <div style={{padding: 30}}>
                                                {deviceChartData2.filter((x) => x.count > 0).map((x, i) => (
                                                    <div key={i} className='row pointer' 
                                                        onClick={() => {
                                                            setSelectedDevices(x.devices)
                                                            setStatus(x.label)
                                                            setIsSrOpen(true)
                                                        }}
                                                    >
                                                        <div style={{ backgroundColor: x.color, width: 25, height: 25, margin: 5}} />
                                                        <div className='col text-start pt-2'><b>{x.label} ({x.count})</b></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>

                                
                                
                                )}
                                
                                {/*메인화면의 날씨 */}                                
                                <Card className='col-xl-3 col-lg-3 col-md-3 text-center rounded-2' style={{display: (viewTab !== 'MAP') ? 'none' : '', backgroundColor: 'transparent'  }}>
                                    <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0,  background: 'linear-gradient(#617dac, #91AEC4)' , color : '#ffffff', fontFamily:'KCC-Hanbit'}} >
                                        <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '0.5rem' }}> 
                                            <div className='d-flex flex-row'>
                                                <div className='d-flex flex-column align-items-left text-left justify-content-center'style={{fontFamily:'KCC-Hanbit', paddingTop: 10}}>                                               
                                                    {formattedDate}
                                                    {/* <div className='row align-items-left text-left justify-content-left' style={{marginTop: 5}}> */}
                                                        <div>
                                                            <span>{weather.location} <Icon icon='Location' fontSize={15}/></span>
                                                        </div>
                                                    
                                                    {/* </div> */}
                                                    
                                                        <div  style={{marginTop: 10}} >
                                                            <div><span style={{fontSize: 30, marginTop: 10, marginLeft: 7}}>{weather.temperature}°<br/></span></div>                                                 
                                                        
                                                        </div>
                                                        <div style={{marginTop: 10}}>{weather.description}</div>
                                                   
                                                   
                                                </div>
                                                <div className='align-items-center justify-content-center text-center' style={{marginTop: 15, marginLeft: 30}}><img src={weather.weatherIconUrl} alt="Weather Icon"/></div>
                                            </div>                        
                                            <div className='d-flex flex-row justify-content-between' style={{marginTop: 10}}>                                                                                                            
                                                <div><span><Icon  style={{}}icon='Wind' fontSize={20} forceFamily='metaria-icon'  /> 
                                                {deviceWeather.wind_speed}m/s<br/></span></div>                                                                                                                                                                                                    
                                                    <div><Icon  style={{transform: 'rotate('+((weather.wind_deg))+'deg)', transition: 'transform 0.3s ease'}}icon='WindDeg' fontSize={20}  />
                                                    {weather.wind_deg}°</div>                                                                                                          
                                                <div><span><Icon icon='Droplet' fontSize={15} forceFamily='bootstrap'/>{weather.humidity}%</span></div>
                                            </div>
                                                
                                            
                                        </CardBody>
                                    </Card>

                                    <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginBottom:2, marginRight: 0,  background: 'linear-gradient(#617dac, #91AEC4)' , color : '#ffffff'}} >
                                        <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '0.5rem' }}> 
                                            <div className='d-flex flex-column align-items-left text-left justify-content-center'style={{fontFamily:'KCC-Hanbit', paddingTop: 10}}>                                               
                                                일몰 / 일출 시간                                            
                                                <div className='d-flex flex-row c text-center justify-content-center' style={{marginTop: 5}}>
                                                    <div className='d-flex flex-column col-xl-6 col-lg-6 col-md-6'>                                                    
                                                        <span style={{fontSize: 20}}><Icon  icon='Sunrise' fontSize={30} forceFamily='bootstrap'  style={{color : '#f27b35'}}/> <br/> {sunriseDate}<br/></span>                                                  
                                                    </div>
                                                    <div className='d-flex flex-column col-xl-6 col-lg-6 col-md-6'>                                                    
                                                        <span style={{fontSize: 20}}><Icon  icon='Sunset' fontSize={30} forceFamily='bootstrap' style={{color : '#f27b35'}} />  <br/>{sunsetDate}<br/></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Card>
                               
                                {/* <Card className={`col-xl-6 col-lg-6 col-md-6 text-center custom-box-shadow rounded-2`} style={{display: (viewTab !== 'MAP') ? 'none' : '', padding: 0, marginLeft: 0, marginRight: 0 , background: 'linear-gradient(#617dac, #91AEC4)'}} >
                                    <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '0.93rem' }}>
                                    
                                     <iframe id='weatherIframe' src={`https://www.weather.go.kr/w/iframe/dfs.do?lat=${location?.latitude || 0}&lon=${location?.longitude || 0}`} width={'100%'} height={'93%'} title="KMA Weather"></iframe>
                                     
                                    </CardBody>
                                </Card> */}

                                <Card className={`col-xl-6 col-lg-6 col-md-6 text-center custom-box-shadow rounded-2`} style={{display: (viewTab !== 'MAP') ? 'none' : '', padding: 0, marginLeft: 0, marginRight: 0 , background: 'linear-gradient(#617dac, #91AEC4)'}} >
                                    <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '0.93rem' }}>
                                        <Icon
                                            icon="Expand"
                                            fontFamily="material-icons"
                                            fontSize="35"
                                            style={{
                                                
                                                position: 'absolute',
                                                top: '10px',
                                                right: '25px', // 원하는 위치에 아이콘 배치
                                                zIndex: 10, // iframe 위에 표시
                                                cursor: 'pointer',
                                                backgroundColor: 'transparent',
                                                borderRadius: '50%',
                                                padding: '5px',
                                            }}
                                            onClick={() => {
                                                setViewTab('Weather');
                                            }}
                                        />                                    
                                        <iframe                                        
                                            id="weatherIframe"
                                            src={`https://www.weather.go.kr/w/iframe/dfs.do?lat=${location?.latitude || 0}&lon=${location?.longitude || 0}`}
                                            width={'100%'}
                                            height={'93%'}
                                            title="KMA Weather"
                                            style={{ border: 'none'}}
                                        ></iframe>   
                                        <span>출처 : 기상청 날씨누리</span>                                 
                                    </CardBody>
                                </Card>       

                            </div>

                            <div className={viewTab === 'MAP2' ? '' : 'text-center'}>
                                <Card className={`custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0, marginTop: 0 }}>
                                    <CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: '0.5rem' }}>
                                        <div
                                            className='position-relative border w-100 d-inline-block bg-l25-light border'
                                            style={{
                                                width: '100%',
                                            }}>
                                            <div id='kakaoMap' className='kakao-map' style={{ width: '100%', height: viewTab === 'MAP' ? 'calc(73vh - 273px)' : 'calc(90vh - 102px)' }}></div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>       
                        </div>
                        </div>
                    )}

                    {/*날씨 아이콘 클릭 시 */}
                    {(viewTab === 'Weather') && (
                        
                            <div>
                            <Card className={` custom-box-shadow rounded-2`} style={{ padding: 0, marginLeft: 0, marginRight: 0, marginTop: 20, height: 850 }}>
                                <CardBody className={`rounded-2`} style={{ padding: '0.5rem' }}>
                                <Icon
                                    icon="ExpandLess"
                                    fontFamily="material-icons"
                                    fontSize="35"
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '20px', // 원하는 위치에 아이콘 배치
                                        zIndex: 10, // iframe 위에 표시
                                        cursor: 'pointer',
                                        backgroundColor: '#fff',
                                        borderRadius: '50%',
                                        padding: '5px',
                                    }}
                                    onClick={() => {
                                        setViewTab('MAP');
                                    }}
                                />
                                <iframe id='weatherIframe' src={`https://www.weather.go.kr/w/index.do#dong/${location?.latitude}/${location?.longitude}`} width={'100%'} height={'100%'} title="KMA Weather"></iframe>  
                                <span>출처 : 기상청 날씨누리</span>                                  
                                </CardBody>
                            </Card>
                            </div>
                        
                    )}     
                    {(viewTab === 'PROFILE') &&
                        <Page className='d-flex flex-row justify-content-between' style={{marginTop: 20}}>
                                <div className='d-flex flex-column justify-content-center'>
                                    <Card className={`custom-box-shadow rounded-2`} style={styles.topCard}>
                                        <CardBody className={`rounded-2 align-items-center text-left`} >
                                            <CardTitle style={{ marginTop: 10 }}>사용자 정보</CardTitle>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('이름')}>
                                                            <InputGroup>
                                                                <Input
                                                                    id={'name'}
                                                                    type={'text'}
                                                                    placeholder={t('이름을 입력해주세요')}
                                                                    value={userInfo.name}
                                                                    onChange={(e) => {
                                                                        setUserInfo({ ...userInfo, name: e.target.value })
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </div>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('아이디')}>
                                                            <Input
                                                                id={'userId'}
                                                                type={'text'}
                                                                placeholder={t('아이디를 입력해주세요')}
                                                                value={userInfo.userId}
                                                                onChange={(e) => {
                                                                    setUserInfo({ ...userInfo, userId: e.target.value })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('휴대폰 번호')}>
                                                            <Input
                                                                id={'phone'}
                                                                type={'text'}
                                                                placeholder={t('휴대폰 번호를 입력해주세요')}
                                                                value={userInfo.phone}
                                                                onChange={(e) => {
                                                                    setUserInfo({ ...userInfo, phone: e.target.value })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('주소')}>
                                                            <InputGroup>
                                                                <Input
                                                                    style={{ backgroundColor: '#ececec' }}
                                                                    disabled={true}
                                                                    id={'address'}
                                                                    type={'text'}
                                                                    placeholder={t('주소를 입력해주세요')}
                                                                    value={userInfo.address}
                                                                    onChange={() => { }}
                                                                    onClick={() => setIsOpenAddress(true)}
                                                                />
                                                                <Button type={'button'} color={'info'} onClick={() => setIsOpenAddress(true)}>{t('주소검색')}</Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </div>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('상세주소')}>
                                                            <Input
                                                                id={'detailAddress'}
                                                                type={'text'}
                                                                placeholder={t('상세주소를 입력해주세요')}
                                                                value={userInfo.detailAddress}
                                                                onChange={(e) => {
                                                                    setUserInfo({ ...userInfo, detailAddress: e.target.value })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('이메일')}>
                                                            <Input
                                                                id={'email'}
                                                                type={'text'}
                                                                placeholder={t('이메일를 입력해주세요')}
                                                                value={userInfo.email}
                                                                onChange={(e) => {
                                                                    setUserInfo({ ...userInfo, email: e.target.value })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <Card className={`custom-box-shadow rounded-2`} style={styles.topCard}>
                                        <CardBody className={`rounded-2 align-items-center text-left`} >
                                            <CardTitle style={{ marginTop: 10 }}>비밀번호 수정</CardTitle>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('비밀번호')}>
                                                            <Input
                                                                id={'password'}
                                                                type={'password'}
                                                                value={userInfo.password}
                                                                onChange={(e) => {
                                                                    setUserInfo({ ...userInfo, password: e.target.value })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('비밀번호 확인')}>
                                                            <Input
                                                                id={'confirmPassword'}
                                                                type={'password'}
                                                                value={userInfo.confirmPassword}
                                                                onChange={(e) => {
                                                                    setUserInfo({ ...userInfo, confirmPassword: e.target.value })
                                                                }}
                                                            />

                                                            {(userInfo.password && userInfo.password !== userInfo.confirmPassword) && <span style={{ color: 'red' }}>일치하지 않습니다.</span>}
                                                            {(userInfo.password && userInfo.password === userInfo.confirmPassword) && <span style={{ color: 'blue' }}>일치합니다.</span>}
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <div className='row'>
                                        <div style={{ marginTop: 10 }}>
                                            <Button type={'button'} style={{ width: 200 }} color={'info'} onClick={() => {
                                                UserService.modify(userInfo).then((res) => {
                                                    console.log('updateUser', res);
                                                    showNotification('사용자 정보 수정', '사용자 정보가 수정되었습니다.', 'success');
                                                });
                                            }}>{t('저장')}</Button>
                                        </div>
                                        {/* <div style={{ marginTop: 20, cursor: 'pointer' }}>
                                            <div
                                                onClick={() => {
                                                    UserService.logout().then(async () => {
                                                        await Promise.all([
                                                            removeItem('access-token'),
                                                            removeItem('refresh-token'),
                                                            removeItem('rootState'),
                                                            removeItem('webToken'),
                                                            removeItem('authUser'),
                                                            user.logout(),
                                                        ]).then(() => {
                                                            navigate(`/login`);
                                                        });
                                                    });
                                                }}
                                            ><u>{t('로그아웃')}</u></div>
                                        </div> */}
                                    </div>
                                </div>
                        </Page>}
                        {(viewTab === 'SETTING') &&
                            <Page className='d-flex flex-row justify-content-between' style={{marginTop: 20}}>
                                <div className='d-flex flex-column justify-content-center'>
                                    <Card className={`custom-box-shadow rounded-2`} style={styles.topCard}>
                                        <CardBody className={`rounded-2 align-items-center text-left`} >
                                            <CardTitle style={{ marginTop: 10 }}>알람 기준 값</CardTitle>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='col-sm-6' style={{ marginTop: 20, height: 243 }}>
                                                        <FormGroup label={t('온도')}>
                                                            <InputGroup>
                                                                <InputGroupText>최고</InputGroupText>
                                                                <Input
                                                                    id={'maxTemperature'}
                                                                    type={'text'}
                                                                    value={settings.maxTemperature}
                                                                    onChange={(e) => {
                                                                        setSettings({ ...settings, maxTemperature: e.target.value })
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                            <InputGroup>
                                                                <InputGroupText>최저</InputGroupText>
                                                                <Input
                                                                    id={'minTemperature'}
                                                                    type={'text'}
                                                                    value={settings.minTemperature}
                                                                    onChange={(e) => {
                                                                        setSettings({ ...settings, minTemperature: e.target.value })
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='col-sm-6' style={{ marginTop: 20 }}>
                                                        <FormGroup label={t('습도')}>
                                                            <InputGroup>
                                                                <InputGroupText>최고</InputGroupText>
                                                                <Input
                                                                    id={'maxHumidity'}
                                                                    type={'text'}
                                                                    value={settings.maxHumidity}
                                                                    onChange={(e) => {
                                                                        setSettings({ ...settings, maxHumidity: e.target.value })
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                            <InputGroup>
                                                                <InputGroupText>최저</InputGroupText>
                                                                <Input
                                                                    id={'minHumidity'}
                                                                    type={'text'}
                                                                    value={settings.minHumidity}
                                                                    onChange={(e) => {
                                                                        setSettings({ ...settings, minHumidity: e.target.value })
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <Card className={`custom-box-shadow rounded-2`} style={styles.topCard}>
                                        <CardBody className={`rounded-2 align-items-center text-left`} >
                                            <CardTitle style={{ marginTop: 10 }}>알림 설정</CardTitle>
                                            <div className='row'>
                                                <div className='col-md-8' style={{ marginTop: 20 }}>
                                                    <ChecksGroup className="d-flex flex-row justify-content-between">
                                                    <Checks label={'이메일'} checked={settings.isReceiveEmail} onChange={() => {
                                                        setSettings({ ...settings, isReceiveEmail: !settings.isReceiveEmail })
                                                        }} />
                                                    <Checks label={'SMS'} checked={settings.isReceiveSms} onChange={() => {
                                                        setSettings({ ...settings, isReceiveSms: !settings.isReceiveSms })
                                                        }} />
                                                        {/* <Checks label={'카카오톡'} checked={settings.kakaotalk} onChange={() => {
                                                            setSettings({ ...settings, kakaotalk: !settings.kakaotalk })
                                                        }} />
                                                        <Checks label={'텔레그램'} checked={settings.telegram} onChange={() => {
                                                            setSettings({ ...settings, telegram: !settings.telegram })
                                                        }} /> */}
                                                    </ChecksGroup>
                                                </div>
                                            </div>
                                        <div className='row' style={{ marginTop: 20 }}>
                                            <div className='col-md-6'>
                                                <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                    <FormGroup label={t('이메일 주소')}>
                                                        <Input
                                                            disabled={!settings['isReceiveEmail']}
                                                            type={'text'}
                                                            value={settings.receiveEmail || ''}
                                                            placeholder={t('이메일 주소를 입력해주세요')}
                                                            onChange={(e) => setSettings({ ...settings, receiveEmail: e.target.value })}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className='col-sm-10' style={{ marginTop: 20 }}>
                                                    <FormGroup label={t('휴대폰 번호')}>
                                                        <Input
                                                            disabled={!settings['isReceiveSms']}
                                                            type={'text'}
                                                            value={settings.receiveSms || ''}
                                                            placeholder={t('휴대폰 번호를 입력해주세요')}
                                                            onChange={(e) => setSettings({ ...settings, receiveSms: e.target.value })}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                        </CardBody>
                                    </Card>
                                    <div className='row'>
                                        <div style={{ marginTop: 10 }}>
                                            <Button
                                            onClick={saveSystemSetting}
                                             type={'button'} style={{ width: 200 }} color={'info'} >{t('설정 저장')}</Button>
                                        </div>
                                        <div style={{ marginTop: 20 }}>
                                            <div>&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                        </Page>}
                </div>
            </div>
            <ArDeviceModal isOpen={isOpen} setIsOpen={setIsOpen} devices={devices} status={status} getDevice={getDevice} />
            <SrErrorModal isOpen={isSrOpen} setIsOpen={setIsSrOpen} devices={selectedDevices} status={status} userId={userId} onDeviceSelect={handleDeviceSelect}/>
            <ArErrorModal isOpen={isErrorOpen} setIsOpen={setIsErrorOpen} devices={errors} status={status} getDevice={getDevice} />
            <UserAddModal isModalOpen={isUserAddOpen} setIsModalOpen={setIsUserAddOpen} selectedUser={selectedDevice} />    
            <Modal isOpen={isOpenAddress} fullScreen='xxl' size='xl' setIsOpen={setIsOpenAddress} isStaticBackdrop={true} isCentered={true}>
                <ModalHeader setIsOpen={setIsOpenAddress}></ModalHeader>
                <ModalBody>
                    <DaumPostcode onComplete={addAddress} style={{ height: '50vh' }} />
                </ModalBody>
                <ModalFooter></ModalFooter>
            </Modal>

            <Modal isOpen={isSleepOpen} setIsOpen={setIsSleepOpen} isCentered={false} isScrollable={true} isStaticBackdrop={true} size='lg'>
                <ModalHeader setIsOpen={setIsSleepOpen}>
                    <ModalTitle>절전 시간을 지정 해주세요. </ModalTitle>
                </ModalHeader>
                <ModalBody >
                    {/* 시리얼 넘버 추가_sh */}
                    <div className='d-flex flex-row justify-content-between'>
                        <div className='col-md-6'>
                            <FormGroup label='시작 시간'>
                                <Input type='time' value={endTime} onChange={(e) => { setEndTime(e.target.value) }} step="60" />
                            </FormGroup>
                        </div>
                        <div className='col-md-6'>
                            <FormGroup label='종료 시간'>
                                <Input type='time' value={startTime} onChange={(e) => { setStartTime(e.target.value) }} step="60" />
                            </FormGroup>
                        </div>
                    </div>
                    <br /><br />해당 시간을 절전 하시겠습니까?
                </ModalBody>
                <ModalFooter>
                    <CardFooterRight>
                        <Button
                            type='button'
                            color='dark'
                            onClick={() => {
                                setIsSleepOpen(false);
                            }}>
                            {t('닫기')}
                        </Button>
                        <Button
                            type='button'
                            color='light'
                            onClick={() => {
                                DeviceService.deviceSetting({
                                    arTermValue: {},
                                    srTermValue: {},
                                    micValue: {},
                                    xyzValue: {},
                                    ftChangeValue: {},
                                    commandValue: {},
                                    sleepValue: {
                                        [detailViewDevice.IMEI + '_' + detailViewDevice.SerialNumber]: 0
                                    }
                                }).then(r => {
                                    if (r.data) {
                                        showNotification(t('절전모드'), t(`절전모드가 ${detailViewDevice.Sleep === 0 ? '해제' : '설정'} 되었습니다.`), 'success')
                                        setIsSleepOpen(false);
                                    }
                                })
                            }}>
                            {t('해제')}
                        </Button>
                        <Button
                            type='button'
                            color='danger'
                            onClick={() => {
                                DeviceService.deviceSetting({
                                    arTermValue: {},
                                    srTermValue: {},
                                    micValue: {},
                                    xyzValue: {},
                                    ftChangeValue: {},
                                    commandValue: {},
                                    sleepValue: {
                                        [detailViewDevice.IMEI + '_' + detailViewDevice.SerialNumber]: 1 + ' ' + startTime + ' ' + endTime
                                    }
                                }).then(r => {
                                    if (r.data) {
                                        showNotification(t('절전모드'), t(`절전모드가 ${detailViewDevice.Sleep === 0 ? '해제' : '설정'} 되었습니다.`), 'success')
                                        setIsSleepOpen(false);
                                    }
                                })
                            }}>
                            {t('설정')}
                        </Button>
                    </CardFooterRight>
                </ModalFooter>
            </Modal>

        </PageWrapper>
    );
});

export default MainPage;